// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__7Qn5Z","content":"Login_content__k2i+F"};